import {
  UseQueryExecute,
  UseQueryState,
  useQuery as useQuery_,
  type AnyVariables,
  type GraphQLRequestParams,
  type RequestPolicy,
  type UseQueryArgs,
  type UseQueryResponse,
} from 'urql'

type NonNullUseQueryResponse<Data = any, Variables extends AnyVariables = AnyVariables> = [
  UseQueryState<Data, Variables> & { data: Data },
  UseQueryExecute,
]

function useQueryWithAutoThrowError<Data = any, Variables extends AnyVariables = AnyVariables>(
  args: UseQueryArgs<Variables, Data>
): UseQueryResponse<Data, Variables> {
  const result = useQuery_(args)
  if (result[0].error) throw result[0].error

  return result
}

/**
 * Because we enable global suspense option, this useQuery also assert that data available
 */
export function useQuery<Data = any, Variables extends AnyVariables = AnyVariables>(
  args: UseQueryArgs<Variables, Data>
): NonNullUseQueryResponse<Data, Variables> {
  const result = useQueryWithAutoThrowError(args)
  if (!result[0].data) throw new TypeError('GraphQL result has no data')

  return result as any
}

type UseNoSuspenseQueryArgs<Variables extends AnyVariables = AnyVariables, Data = any> = {
  requestPolicy?: RequestPolicy
  pause?: boolean
} & GraphQLRequestParams<Data, Variables>

const noSuspense = { suspense: false }

export function useNoSuspenseQuery<Data = any, Variables extends AnyVariables = AnyVariables>(
  args: UseNoSuspenseQueryArgs<Variables, Data>
): UseQueryResponse<Data, Variables> {
  return useQueryWithAutoThrowError<Data, Variables>({
    ...args,
    context: noSuspense,
  })
}
